import { render } from "./DocumentOutlineIcon.vue?vue&type=template&id=3b816bac"
import script from "./DocumentOutlineIcon.vue?vue&type=script&lang=js"
export * from "./DocumentOutlineIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__